<template>
  <v-container fluid>
    <MaterialCard title="Export Franchisee Data" inline icon="mdi-mail">
      <v-card-actions> </v-card-actions>
      <v-row>
          <v-col cols="12" md="6">
            <label class="font-weight-medium body-2"> Select Column</label>
            <v-autocomplete
              class="my-0 py-1"
              key="id"
              v-model="selectedColumns"
              placeholder="Select Column"
              menu-props="auto"
              :items="columnList"
              multiple
            >
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-btn
              class="px-2 ml-1 ma-1"
              small
              @click="getFranchiseeList()"
            >
              Get Franchisee
            </v-btn>
          </v-col>
        </v-row>
        <v-card-component>
        <div class="d-flex justify-end">
          <v-btn
            class="mb-2"
            :disabled="!(franchiseeList.length > 0)"
            @click="exportToCSV()"
            v-if="$vuetify.breakpoint.smAndUp"
            color="primary"
            elevation="1"
          >
            <v-icon left>mdi-download</v-icon>
            Export All
          </v-btn>
        </div>

        <v-data-table
          sort-by
          hide-default-footer
          :items-per-page="-1"
          :headers="headers"
          :items="franchiseeList"
          :search="search"
          item-key="index"
        >
        </v-data-table>
      </v-card-component>
    </MaterialCard>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import Utils from '@/utils'
import VCardComponent from '@/components/template/VCardComponent.vue'
export default {
  name: 'FranchiseeData',
  components: {
    MaterialCard,
    VCardComponent
  },

  data: function () {
    return {
      headers: [
        {
          text: 'Region',
          sortable: true,
          value: 'Region'
        },
        {
          text: 'Sub Region',
          value: 'SubRegion',
          sortable: true
        },
        {
          text: 'Type',
          value: 'Type',
          sortable: true
        },
        {
          text: 'Franchisee Model',
          value: 'Model',
          sortable: true
        },
        {
          text: 'Franchisee Name',
          value: 'FranchiseeName',
          sortable: true
        },
        {
          text: 'Franchisee ID',
          value: 'FranchiseeID',
          sortable: true
        },
        {
          text: 'B2B ID',
          value: 'B2BID',
          align: 'center'
        },
        {
          text: 'BP Name',
          value: 'BPName',
          align: 'center'
        },
        { text: 'Mobile No', value: 'mobileno', sortable: true },
        { text: 'Email', value: 'email', sortable: true },
        {
          text: 'Academic Year',
          value: 'AcademicYear',
          align: 'center'
        },
        { text: 'Address', value: 'Address', sortable: true },
        { text: ' City ', value: 'City', sortable: true },
        {
          text: 'State',
          value: 'State',
          sortable: true
        },
        { text: 'Country', value: 'country', sortable: true }
      ],
      selectedColumns: [],
      columnList: [],
      loadingComponent: null,
      isWrite: false,
      isLoading: false,
      search: '',
      franchiseeList: []
    }
  },
  created: async function () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getColumnList()
  },

  methods: {
    getColumnList: async function () {
      try {
        this.isLoading = true
        let response = await http.get(
          `${constants.API_URL}/api/report/get-franchisee-columns`
        )
        this.columnList = response.data
        this.columnList.unshift('All')
      } catch (e) {
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },
    getFranchiseeList: async function () {
      if (!this.selectedColumns.length) {
        return this.$buefy.dialog.alert({
          message: 'Please select columns',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      try {
        this.isLoading = true
        if (this.selectedColumns.includes('All')) {
          this.selectedColumns = this.columnList
          this.selectedColumns.shift()
        }

        let res = await http.post(
          `${constants.API_URL}/api/report/get-franchisee-data`, { columnNames: this.selectedColumns }
        )
        this.franchiseeList = res.data.map(franchisee => {
          let franchiseeObject = {}
          franchiseeObject.Region = franchisee.region
          franchiseeObject.SubRegion = franchisee.subRegion
          franchiseeObject.Model = franchisee.franchiseeModel.title
          franchiseeObject.Type = franchisee.type
          franchiseeObject.FranchiseeName = franchisee.companyName
          franchiseeObject.FranchiseeID = franchisee.id
          franchiseeObject.B2BID = franchisee.b2bID
          franchiseeObject.AcademicYear = franchisee.franchiseeAcademicYear.academicYear
          franchiseeObject.BPName = `${franchisee.firstname} ${franchisee.lastname}`
          franchiseeObject.email = franchisee.email
          franchiseeObject.mobileno = franchisee.mobileno
          franchiseeObject.Address = franchisee.address1
          franchiseeObject.City = franchisee.city
          franchiseeObject.State = franchisee.state
          franchiseeObject.country = franchisee.country

          return franchiseeObject
        })
      } catch (e) {
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },

    exportToCSV () {
      const header = Object.keys(this.franchiseeList[0]).join(',')
      const csv = this.franchiseeList.map(item => {
        return Object.values(item).map(value => {
          if (typeof value === 'string' && value.includes(',')) {
            return `"${value}"`
          }
          return value
        }).join(',')
      }).join('\n')

      const blob = new Blob([header + '\n' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', 'franchiseeData.csv')
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
